import helper from '@/commons/helper';
import axios from 'axios';

export default {
  getAccountDetail() {
    const url = helper.initUrl('vendor/clean/account');
    return axios.get(url);
  },

  getLoginSetting(prefixCode) {
    const endpoint = 'vendor/' + prefixCode + '/settings';
    const url = helper.initUrl(endpoint, false);
    return axios.get(url);
  },

  destroySession() {
    const url = helper.initUrl('vendor/clean/session/destroy');
    return axios.get(url);
  },

  getCleaningInfo(data) {
    const url = helper.initUrl('vendor/clean/info');
    return axios.post(url, data);
  },

  updateCleaningStatus(data) {
    const url = helper.initUrl('vendor/clean/status');
    return axios.post(url, data);
  },

  markUnitReady(unitId, reservationNumber) {
    const endpoint = 'vendor/clean/arrival/ready/' + unitId + '/' + reservationNumber;
    const url = helper.initUrl(endpoint);
    return axios.put(url);
  },

  unmarkUnitReady(unitId, reservationNumber) {
    const endpoint = 'vendor/clean/arrival/ready/' + unitId + '/' + reservationNumber;
    const url = helper.initUrl(endpoint);
    return axios.delete(url);
  },

  getSecretQuestion(prefixCode, vendorId) {
    const endpoint = 'vendor/' + prefixCode + '/clean/' + vendorId + '/password/secretQuestion';
    const url = helper.initUrl(endpoint, false);
    return axios.get(url);
  },

  resetPassword(data, prefixCode, vendorId) {
    const endpoint = 'vendor/' + prefixCode + '/clean/' + vendorId + '/password/reset';
    const url = helper.initUrl(endpoint, false);
    return axios.post(url, data);
  },

  changePassword(data) {
    const url = helper.initUrl('vendor/clean/authentication');
    return axios.post(url, data);
  },

  updateAuthSettings(data) {
    const url = helper.initUrl('vendor/clean/authentication');
    return axios.post(url, data);
  },

  createSession(prefixCode, vendorId, password) {
    const url = helper.initUrl('vendor/clean/session/create', false);

    const data = {
      prefixCode: prefixCode,
      vendorId: vendorId,
      password: password
    };

    return axios.post(url, data);
  }
};
